import BaseHelper from './BaseHelper'
// import {brushX as d3_brushX} from 'd3-brush'

import { select as d3_select, pointer as d3_pointer} from 'd3-selection'
export default class BrushHelper extends BaseHelper {
  static configName = 'BrushHelper'
  static defaultConfig = {
    index: 102,
    /**
     * Enables the tool for brush selection along the X axis
     */
    enabled: {
      type: Boolean,
      default: false,
      exposed: true,
    },
    /**
     * Enables the tooltip when using the brush selection along the X axis
     */
    showTooltip: {
      type: Boolean,
      default: true,
      exposed: true,
    }
  }
  static init() {
    
  }
  static beforeDraw() {
     }
  static draw() {
    
    
  }
  static afterDraw() {
    // let brush = d3_brushX()
    // brush.on('brush',(d)=>{
    //   d3_select(this.$root).select('.selection').attr('x',0)
    //   console.log("update brush")
    // })
    // d3_select(this.$root).call(brush)
    let brushLayer = this.content.selectAll('.brush-layer').data(this.config.BrushHelper.enabled?[null]:[],(d)=>d)
    brushLayer.exit().remove()
    brushLayer = brushLayer.merge(brushLayer.enter().append('g').attr('class','brush-layer'))
    brushLayer.raise()
    if(!this.config.BrushHelper.enabled) return
    let sensor = brushLayer.selectAll('.sensor').data([null])
    sensor = sensor.enter().append("rect")
        .attr("class", "sensor")
        .attr("pointer-events", "all")
        .attr("cursor", 'ew-resize')
        .attr('opacity','0')
        .merge(sensor)
          .attr("x", 0)
          .attr("y", 0)
          .attr("width", this.contentSize.width)
          .attr("height", this.contentSize.height);


    
    let snap = (point)=>{
      let dataPoints = this.data.map((line)=>line.value).flat(1)
      let closest = dataPoints.reduce((closest,datum)=>{
        let x = this.axes.x.scale(datum.id)
        let dist = Math.abs(x-point[0])
        if(dist<closest.dist) closest= {dist,datum,x}
        return closest
      },{dist:Infinity})
      // return [closest.x,point[1]]
      return closest
    }
    
    let dragging = false
    let drawBrush = (e)=>{    
      let selection = brushLayer.selectAll('.selection').data([null])
      selection.exit().remove()
      let selectionEnter = selection.enter().append('g').attr('class','selection')
      selectionEnter.attr('pointer-events','none')
      selectionEnter.append('line')
      selectionEnter.append('rect')
      selection = selection.merge(selectionEnter)
      let rect = selection.select('rect')
      let overlayColor = this.config.skin === 'light' ? 'rgba(255,255,255)' : 'rgba(31, 31, 31)'
      
      
      let point //= e?d3_pointer(e,brushLayer.node()):[this.contentSize.width,0]
      if(e){
        point = d3_pointer(e,brushLayer.node())
      } else if (rect.node() && rect.node().__x__){
        point = [rect.node().__x__,0]
      } else {
        point = [this.contentSize.width,0]
      }
      let closest = snap(point)
      point[0] = [closest.x]
      rect.node().__x__ = closest.x
      // if(e){
      //   if(rect.node() && closest.x === rect.node().__x__) return null
      //   rect.node().__x__ = closest.x
      // }
      selectionEnter.select('rect').attr('fill',overlayColor).attr('opacity',0.8)
        .attr('y',0)
        .attr('height',this.contentSize.height)
        .attr('x',point[0])
        .attr('width',this.contentSize.width-point[0])
        
      rect 
        .attr('y',0)
        .attr('height',this.contentSize.height)
        .transition().duration(dragging?0:400)
        .attr('fill',overlayColor)
        .attr('x',point[0])
        .attr('width',this.contentSize.width-point[0])
      
      let line = selection.select('line')
      let lineEnter = line.enter().append('line').attr('class','line')
      let lineColor = this.config.skin === 'light' ? '#888' : '#e3e3e3'

      lineEnter.attr('pointer-events','none').attr('stroke-width','hairline')
      line = line.merge(lineEnter)
      line
        .attr('stroke', lineColor)
        .attr('y1',0)
        .attr('y2',this.contentSize.height)
        .transition().duration(dragging?0:400)
        .attr('x1',point[0])
        .attr('x2',point[0])
      
      if(this.config.BrushHelper.showTooltip) drawTooltip(closest.datum)
      return closest.datum
    }

    let drawTooltip = (datum) => {
      let root= d3_select(this.$root.parentNode)
      let tooltip = root.selectAll('.brush-tooltip').data([datum],d=>d.id)
      let tooltipEnter = tooltip.enter().append('div').attr('class','brush-tooltip')
        .style('border', 'solid 1px #EBEBEB')
        .style('border-radius', '5px')
        .style('padding', '6px 12px')
        .style('text-align', 'center')
        .style('white-space', 'wrap')
        .style('font-size', '14px')
        .style('max-width', '180px')
        .style('line-height', '1.4em')
        .style('box-shadow','0px 6px 6px rgba(111,119,121, 0.15)')
      tooltipEnter.append('div')
        .attr('class', 'content-wrapper')
        .style('width', 'max-content')
        .style('max-width', '100%')
        .style('word-wrap', 'break-word')

      tooltip.exit().remove()
      tooltip = tooltip.merge(tooltipEnter)

      tooltip.style('background',this.config.skin==='dark'?'#222':'#fff')
        .style('color',this.config.skin==='dark'?'#fff':'#222')
        
      //bad performancer... 3 getBoundingClientRect...
      let offset = this.$root.getBoundingClientRect()
      let parentOffset = this.$root.parentNode.getBoundingClientRect()
      offset = {top: offset.top - parentOffset.top, left: offset.left-parentOffset.left}
      let tickValues = this.axes.x.func.tickValues()
      let firstTick = tickValues ? tickValues[0] : this.axes.x.scale.domain()[0]
      
      tooltip.select('.content-wrapper')//.text(firstTick+' to '+ datum.id)
        .text(this.valueWithUnit(firstTick, 'x')+' - '+this.valueWithUnit(datum.id, 'x'))
      let x = (offset.left + this.axes.x.scale(datum.id) + this.margin.left)
      tooltip.style('position','absolute')
        .style('left',x+'px')
        .style('top',(offset.top + this.margin.top)+'px')
        .style('transform',()=>{
          if(x>this.contentSize.width*0.7) return 'translate(calc(-100% - 5px),0)'
          else return 'translate(5px,0)'
        })
    }
    let started = (e)=>{
      let datum = drawBrush(e)
      dragging = true
      datum && this.emit('brush', datum)
    }
    
    let touchmoved = (e)=>{
      if(!dragging) return
      let datum = drawBrush(e)
      datum && this.emit('brush', datum)
    }
    let ended = (e)=> {
      dragging=false
    }
    
    let touchable = function (){
      return navigator.maxTouchPoints || ("ontouchstart" in document.body);
    }
    sensor.attr("pointer-events", "all")
    if(touchable()){
      sensor.on("touchstart", (e)=>started(e.touches[0]))
      .on("touchmove", (e)=>touchmoved(e.touches[0]))
      .on("touchend", (e)=>ended(e.touches[0]))
    } else {
      sensor.on("mousedown", started)
      .on("mousemove", touchmoved)
      .on("mouseup", ended)
    }

    drawBrush()
  }
}
